import { useState, useEffect } from 'react';

const TypewriterText = ({ text, speed = 30, onComplete }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    // Reset state when text changes
    setDisplayText('');
    setHtmlContent('');
    setCurrentIndex(0);
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timer = setTimeout(() => {
        // Check if we're at the start of an HTML tag
        if (text[currentIndex] === '<') {
          // Find the end of the tag
          const tagEnd = text.indexOf('>', currentIndex);
          if (tagEnd !== -1) {
            // Include the entire tag
            setHtmlContent(prev => prev + text.slice(currentIndex, tagEnd + 1));
            setCurrentIndex(tagEnd + 1);
            return;
          }
        }
        
        setHtmlContent(prev => prev + text[currentIndex]);
        setCurrentIndex(currentIndex + 1);
      }, speed);

      return () => clearTimeout(timer);
    } else if (onComplete) {
      onComplete();
    }
  }, [currentIndex, text, speed, onComplete]);

  return (
    <span 
      className="typewriter-text"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default TypewriterText; 